/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 27.06.25
 *
 */
export const InvoiceStatus = Object.freeze({
	NOT_SET: "NOT_SET",
	PREVIEW: "PREVIEW",
	DRAFT: "DRAFT",
	SENT: "SENT",
	PAID: "PAID",
	OVERDUE: "OVERDUE",
	CANCELLED: "CANCELLED",
	REFUNDED: "REFUNDED",
	PARTIALLY_REFUNDED: "PARTIALLY_REFUNDED",
	FAILED: "FAILED"
})
export const getStatusNameFromStatus = (status) => {
	switch (status) {
		case InvoiceStatus.DRAFT:
			return "Draft";
		case InvoiceStatus.SENT:
			return "Sent";
		case InvoiceStatus.PAID:
			return "Paid";
		case InvoiceStatus.OVERDUE:
			return "Overdue";
		case InvoiceStatus.CANCELLED:
			return "Cancelled";
		case InvoiceStatus.REFUNDED:
			return "Refunded";
		case InvoiceStatus.PARTIALLY_REFUNDED:
			return "Partially Refunded";
		case InvoiceStatus.FAILED:
			return "Failed";
		default:
			return "Not Set";
	}
}
